const columns = [
  {
    key: "deviceCode",
    zh: "整机编号",
    en: "Device Code",
    width: "14%"
  },
  {
    key: "company",
    zh: "公司名称",
    en: "Company",
    width: "19%"
  },
  {
    key: "model",
    zh: "机型",
    en: 'Model',
    width: "9%"
  },
  {
    key: "avgPressure",
    zh: "平均压力(MPa)",
    en: "Average Pressure(MPa)",
    width: "12%",
    tooltip: true
  },
  {
    key: "ratedPressure",
    zh: "设定压力(MPa)",
    en: "Rated Pressure(MPa)",
    width: "12%",
    tooltip: true
  },
  {
    key: "avgFrequency",
    zh: "平均频率(Hz)",
    en: "Average Frequency(Hz)",
    width: "11%",
    tooltip: true
  },
  {
    key: "ratedFrequency",
    zh: "上限频率(Hz)",
    en: "Rated Frequency(Hz)",
    width: "11%",
    tooltip: true
  },
  {
    key: "percentage",
    zh: "气量不足率",
    en: "Percentage",
    width: "12%"
  }
]

export default columns